import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, SxProps } from '@mui/material'
import { CustomDialogContent, DialogHeader } from './ClientConfigToolStyles'
import React, { FormEvent } from 'react'
import CloseOutlined from '@mui/icons-material/CloseOutlined'
import InfoOutlined from '@mui/icons-material/InfoOutlined'

interface ViewMigratedDataConfirmDialogProps {
  open: boolean
  handleClose: () => void
  handleSubmit: (event: FormEvent) => void
  isEnabling: boolean
  isSubmitting: boolean
}

const sx: SxProps = {
  '& .MuiDialog-container': {
    alignItems: 'flex-start'
  }
}

function ViewMigratedDataConfirmDialog({open, handleClose, handleSubmit, isEnabling, isSubmitting}: ViewMigratedDataConfirmDialogProps) {
  return (
    <Dialog
      PaperProps={{sx: {marginTop: '3.5rem', width: '37.5rem'}}}
      open={open}
      sx={sx}
    >
      <DialogTitle>
        <Grid
          columns={17}
          container
          direction="row"
          spacing={0}
        >
          <Grid item xs={2}>
            <InfoOutlined sx={{ color: '#2563EB', fontSize: 22 }} />
          </Grid>
          <Grid item xs={14}/>
          <Grid item xs={1}>
            <CloseOutlined onClick={isSubmitting ? undefined : handleClose} sx={{color: 'rgba(0, 0, 0, 0.87)'}} />
          </Grid>
        </Grid>
        <DialogHeader>{isEnabling ? 'Enable Legacy I-9 Viewing in Tracker?' : 'Revert Legacy I-9 Viewing to TalentReef?'}</DialogHeader>
      </DialogTitle>
      <DialogContent>
        <CustomDialogContent>
          {isEnabling 
            ? `This will allow users to view migrated legacy I-9 records in Tracker.
               New I-9 records will continue to be created and managed in Tracker as usual.
               You can switch back to viewing legacy I-9s in TalentReef at any time.`
            : `This will switch legacy I-9 record viewing back to TalentReef.
               Migrated data in Tracker will not be deleted and can be re-enabled at any time.
               New I-9 records created in Tracker will not be affected.`
          }
        </CustomDialogContent>
      </DialogContent>
      <DialogActions sx={{padding: '0.5rem 1.5rem'}}>
        <Button  disabled={isSubmitting} onClick={handleClose}>Cancel</Button>
        <Button 
          color="primary" 
          disabled={isSubmitting}
          onClick={handleSubmit}
          variant="contained"
        >
          {isEnabling ? 'Enable' : 'Disable'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ViewMigratedDataConfirmDialog
